import React, { useCallback } from 'react';
import { Button, Form, TimePicker, Select, AutoComplete } from 'antd';
import { AddRoutineFormWrapper } from './routine.style';
import { day_type } from 'common/constants/index';
import { useSubject } from 'features/result/hooks/useSubject';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useRoutine } from '../hooks/useRoutine';
import { useGrade } from '../hooks/useGrade';
import moment from 'moment';
import _ from 'lodash';
import { UserModel } from 'data/user/user.model';
import { GradeModel } from 'data/grade/grade.model';

export const AddRoutineForm = (props: any) => {
  const [form] = Form.useForm();
  const { onVisibleChange, onSetReloadRoutine } = props;
  const { fetchSubject } = useSubject();
  const { publishRoutine, fetchTeacherBySearch, error } = useRoutine();
  const { fetchGrade } = useGrade();
  const subjects = useSelector((state: RootState) => state.subject);
  const grade = useSelector((state: RootState) => state.grade);
  const users = useSelector((state: RootState) => state.user);
  const [endValue, setEndValue] = React.useState('');
  const [startValue, setStartValue] = React.useState('');
  const [result, setResult] = React.useState<UserModel[]>([]);
  const [gradeData, setGradeData] = React.useState<GradeModel>({
    id: '',
    startTime: '',
    endTime: '',
    sections: [],
  });
  const [teacherId, setTeacherId] = React.useState('');
  const handleSubmit = () => {
    publishRoutine(
      {
        ...form.getFieldsValue(),
        start: startValue,
        end: endValue,
        teacherId: teacherId,
      },
      form,
      onVisibleChange,
      onSetReloadRoutine,
    );
  };

  const handleSelect = (value: any) => {
    users.data.map((user) => {
      if (user.full_name === value) {
        console.log('teacher', user);
        setTeacherId(user.teacherId);
      }
    });
  };

  const handleSearch = (value: string) => {
    debounce(value);
    let res: UserModel[] = [];
    if (!value) {
      res = [];
    } else {
      users.data.map((user) => {
        res.push(user);
      });
    }
    setResult(res);
  };

  const debounce = useCallback(
    _.debounce((value: string) => {
      fetchTeacherBySearch(value);
    }, 800),
    [],
  );

  React.useEffect(() => {
    fetchSubject();
    fetchGrade();
    //eslint-disable-next-line
  }, []);

  return (
    <AddRoutineFormWrapper>
      <Form form={form} name="nest-messages" layout="vertical" size="large">
        <div className="time">
          <Form.Item label="Start Time" name="start">
            <TimePicker
              bordered={false}
              size="small"
              format="HH:mm "
              onChange={(date) => setStartValue(moment(date).format('HH:mm'))}
              value={startValue !== '' ? moment(startValue, 'HH:mm') : null}
              style={{ padding: '0px', border: '0px', width: '200px' }}
            />
          </Form.Item>
          <Form.Item label="End Time" name="end">
            <TimePicker
              bordered={false}
              size="small"
              format="HH:mm "
              onChange={(date) => setEndValue(moment(date).format('HH:mm'))}
              value={endValue !== '' ? moment(endValue, 'HH:mm') : null}
              style={{ padding: '0px', border: '0px', width: '200px' }}
            />
          </Form.Item>

          <Form.Item label="Day" name={'day'}>
            <Select defaultValue="Select Day" style={{ width: '200px' }}>
              {day_type.map((item) => (
                <Select.Option value={item.value}>{item.title}</Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <Form.Item label="Subject" name={'subjectId'}>
          <Select defaultValue="Select Subject">
            {subjects.data.map((item) => (
              <Select.Option value={item.id}>{item.title}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <div className="classSection">
          <Form.Item label="Grade" name="gradeId" style={{ width: 250 }}>
            <Select
              defaultValue="Select Grade"
              onSelect={(value) => {
                grade.data.map((item) => {
                  if (item.id === value) {
                    setGradeData(item);
                  }
                });
              }}
            >
              {grade.data.map((item) => (
                <Select.Option value={item.id}>{item.id}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Section" name="sectionId" style={{ width: 250 }}>
            <Select defaultValue="Select Section">
              {gradeData.sections.map((section) => (
                <Select.Option value={section.id}>{section.id}</Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <Form.Item label="Teacher" name="teacherId">
          <Select
            showSearch
            onSearch={handleSearch}
            defaultValue="Search Teacher"
            style={{ width: 200 }}
            onSelect={handleSelect}
          >
            {result.map((teacher) => (
              <Select.Option key={teacher.teacherId} value={teacher.full_name}>
                {teacher.full_name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" onClick={handleSubmit}>
            SAVE
          </Button>
        </Form.Item>
      </Form>
    </AddRoutineFormWrapper>
  );
};

export default AddRoutineForm;
